import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";
import {memo} from "react";

import {Box} from "../ui/box";
import {HStack} from "../ui/hstack";

const progressStepItemStyle = tva({
    base: "flex-1 rounded-full w-5 h-1",
    variants: {
        isActive: {
            true: "bg-blue-600",
            false: "bg-gray-200"
        }
    },
    defaultVariants: {
        isActive: false
    }
});

const progressStepContainerStyle = tva({
    base: "items-start"
});

type Props = {
    step: number;
    totalSteps: number;
    className?: string;
};

const Steps: React.FC<Props> = ({step, totalSteps, className}) => {
    return (
        <HStack className={progressStepContainerStyle({className})} space="sm">
            {[...Array(totalSteps)].map((_, index) => (
                <Box
                    key={index}
                    className={progressStepItemStyle({
                        isActive: index + 1 === step
                    })}
                />
            ))}
        </HStack>
    );
};

export default memo(Steps);
